import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { BillingBannerInfo } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class BillingBannerApi {
    public static getBillingBannerInfo(_xmStore: XmStore, http: HttpClient): Observable<BillingBannerInfo> {
        return http.get('/xm/promotions', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: BannerResponse) => BillingBannerInfo.create<BillingBannerInfo>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_BILLING_BANNER] = BillingBannerApi.getBillingBannerInfo;
